var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{attrs:{"dark":"","small":"","color":"success lighten-1 ma-0"},on:{"click":_vm.downloadFiles}},[_c('v-icon',{attrs:{"left":"","dark":""}},[_vm._v("cloud_download")]),_vm._v(" "+_vm._s(_vm.$t('customers.export'))+" ")],1)}
var staticRenderFns = []

export { render, staticRenderFns }